<template>
    <div>
        <b-row>
            <b-col>
                <b-form @submit.prevent="save">
                    <b-card>

                        <b-form-row>

                            <b-col cols="12" class="text-left">
                                <LgFinderPageEmpresa @input="mudarEmpresa" :prefix='[prefix]' v-model="form.empresa"
                                    id="finderPageEmpresaFormAdicionarApoliceSeguroIBP" label="Empresa:*" required />

                            </b-col>

                        </b-form-row>



                        <b-form-row>
                            <b-col cols="10" class="text-left">
                                <lg-form-input invalidFeedback="Informe o a descrição" description=""
                                    v-model="form.descricao" label="Descrição*" maxlength="200" />
                            </b-col>


                        </b-form-row>
                        <b-form-row>
                            <b-col cols="4">
                                <lg-form-date description="" v-model="form.dataInicial" typeDatepicker="date"
                                    label="Data Inicial*" />
                            </b-col>
                            <b-col cols="4" class="ml-2">
                                <lg-form-date description="" v-model="form.dataFinal" typeDatepicker="date"
                                    label="Data Final*" />
                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <b-col cols="4">
                                <lg-form-input-number invalidFeedback="O valor deve ser informado!"
                                    description=" " 
                                    v-model="form.valor" label="Valor Assegurado(R$):*" 
                                    :precision="{ min: 2, max: 2 }" :isMoney="true" />
                            </b-col>

                            <b-col cols="4" class="ml-2">
                                <lg-form-input-number invalidFeedback="O valor deve ser informado!"
                                    description=" " 
                                    v-model="form.numero" label="Nº Apólice:*" 
                                    :precision="{ min: 0, max: 0 }" />
                            </b-col>
                        </b-form-row>

                    </b-card>
                </b-form>
            </b-col>
        </b-row>


        <b-form-row>

            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
                <b-button id="salvarLocalCadastro" class=" my-2" size="sm" pill variant="success" @click="save">
                    <b-icon icon="check-circle" />
                    <b-tooltip target="salvarLocalCadastro" title="Salvar"></b-tooltip>

                </b-button>

                <b-button id="cancelarLocalCadastro" class=" my-2 ml-2" size="sm" pill variant="danger"
                    @click="cancelar">
                    <b-icon icon="x-circle" />
                    <b-tooltip target="cancelarLocalCadastro" title="Cancelar"></b-tooltip>

                </b-button>
            </b-col>
            <b-col cols="3"></b-col>

        </b-form-row>


    </div>
</template>
<script>
import { getContext } from "@/core/auth";
import moment from 'moment';
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import ApoliceSeguroIBPService from "@/core/api/ApoliceSeguroIBPService";
import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue"
import LgFormInputNumber from "@/core/components/Form/LgFormInputNumber.vue";
export default {
    components: {
        LgFormInput,
        LgFinderPageEmpresa,
        LgFormDate,
        LgFormInputNumber
    },
    mixins: [FormResourceMixin, ListResourceMixin],
    props: {
        prefix: {
            tipe: String,
            default: "",
        },
        title: {
            tipe: String,
            default: "cadastro",
        },

        id: Number,
        modal: Boolean,
        idItemBemPermanente: Number,
        idApolice: Number
    },
    data() {
        return {

            form: {
                numero: '',
                valor: '',
                descricao: '',
                dataInicial: '',
                dataFinal: '',
                empresa: { id: null },

            },
        };
    },
    async beforeMount() {
        this.$apoliceSeguroIBPService = new ApoliceSeguroIBPService();

        if (this.idApolice) {
            this.$apoliceSeguroIBPService.findById(this.idApolice).then(response => {
                this.form = response.data;
                this.form.idItemBemPermanente = this.id;

            })
        }
        else
            this.form.idItemBemPermanente = this.id;

    },



    methods: {
        mudarEmpresa(empresa) {
            this.form.empresa = empresa;

        },
        save() {

            if (!this.form.empresa.id) {
                this.$notify({
                    type: "danger",
                    message: 'Empresa é obrigatória',
                });

                return;
            }


            if (!this.form.descricao) {
                this.$notify({
                    type: "danger",
                    message: 'Descrição é obrigatória',
                });

                return;
            }


            if (!this.form.dataInicial) {
                this.$notify({
                    type: "danger",
                    message: 'Data Inicial é obrigatória',
                });

                return;
            }

            if (!this.form.dataFinal) {
                this.$notify({
                    type: "danger",
                    message: 'Data Final é obrigatória',
                });

                return;
            }


            if (!this.form.numero) {
                this.$notify({
                    type: "danger",
                    message: 'Número da Apólice é obrigatório',
                });

                return;
            }

            if (!this.form.valor) {
                this.$notify({
                    type: "danger",
                    message: 'Valor Assegurado é obrigatório',
                });

                return;
            }

            this.form.repCriacao = getContext().usuario.nome;
            this.form.dataFinal = moment(this.form.dataFinal);
            this.form.dataInicial = moment(this.form.dataInicial);
            this.form.empresa = { id: this.form.empresa.id };
            this.form.id = this.idApolice;

            if (this.idApolice) {
                this.$apoliceSeguroIBPService.editar(this.form).then(response => {
                    this.$notify({
                        type: "success",
                        message: response.data,
                    });
                    this.fecharModal();
                });
            }
            else {

                this.$apoliceSeguroIBPService.salvar(this.form).then(response => {
                    this.$notify({
                        type: "success",
                        message: response.data,
                    });
                    this.fecharModal();
                });

            }

        },
        fecharModal() {
            this.$emit('fecharModal');
        },

        editar() {
            this.$notify({
                type: "danger",
                message: 'Esse registro não pode ser editado. Por favor, inclua um novo',
            });

        },

    },
};
</script>
<style>
.hand-pointer {
    cursor: pointer;
}
</style>